import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectorRef, Output } from '@angular/core';

//User-Defined Components
import { Permission } from './../../../model/permission';
import { PermissionService } from '../../../service/component_dependent/permission.service';

import { NotifierService } from '../../../service/component_dependent/notifier.service';
import { StorageService } from '../../../service/managers/storage.service';
import { Router } from '@angular/router';
import { JsonManager } from '../../../service/managers/json-manager';
//Angular powered Bootstrap

@Component({
  selector: 'app-permissions-profile',
  templateUrl: './permissions-profile.component.html',
  styleUrls: ['./permissions-profile.component.scss']
})
export class PermissionsProfileComponent implements OnInit {

  permission: Permission = {
    id: null,
    name: null,
    display_name: null,
    description: null,
    created_at: null,
    updated_at: null,
  };
  permissions: Permission[];

  constructor(private servicePermission: PermissionService, private notifierService: NotifierService,
    private router: Router) {

  }

  ngOnInit() {

  }

  public saveAndExit() {
    this.onSubmit("SAE");
  }

  public saveAndInsert() {
    this.onSubmit("SAI");
  }

  public onSubmit(mode: string) {
    this.servicePermission.storePermission(this.permission).subscribe(
      (data: any) => {
        this.notifierService.showSuccess(data.message);
        if (mode == "SAI") {
          this.clearRegistrationForm();
        } else if (mode == "SAE") {
          this.router.navigateByUrl("/joytogive/permissions");
        }
      },
      (error: any) => {
        this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(error.error.message));
      },
    );
  }

  private clearRegistrationForm() {
    this.permission.id = null;
    this.permission.name = null;
    this.permission.display_name = null;
    this.permission.description = null;
  }

}
